import { Map } from 'immutable';

import * as t from '../actions/helpPopupsActionTypes';

const initialState = Map({
  disableQuestionError: '',
  disableQuestionLoading: false,
  disableQuestionSuccess: false,
  disableQuestionResponse: {},

  reportQuestionError: '',
  reportQuestionLoading: false,
  reportQuestionSucces: false,
});

const reducer = function featuredBlogReducer(state = initialState, action) {
  switch (action.type) {
    case t.DISABLE_QUESTION_ERROR:
      return state.set('disableQuestionError', action.error);

    case t.DISABLE_QUESTION_SUCCESS:
      return state.set('disableQuestionSuccess', action.success);

    case t.DISABLE_QUESTION_LOADING:
      return state.set('disableQuestionLoading', action.isLoading);

    case t.DISABLE_QUESTION_RESPONSE:
      return state.set('disableQuestionResponse', action.response);

    case t.REPORT_QUESTION_ERROR:
      return state.set('reportQuestionError', action.error);

    case t.REPORT_QUESTION_SUCCESS:
      return state.set('reportQuestionSucces', action.success);

    case t.REPORT_QUESTION_LOADING:
      return state.set('reportQuestionLoading', action.isLoading);

    default:
      return state;
  }
};

export default reducer;
